import { useEffect, useRef, useState } from "react";

export function useIntervalValue(compute: () => string, intervalMs: number): string {
  const [value, setValue] = useState(compute);
  const computeRef = useRef(compute);
  computeRef.current = compute;

  useEffect(() => {
    const interval = setInterval(() => setValue(computeRef.current()), intervalMs);
    return () => clearInterval(interval);
  }, [intervalMs]);

  return value;
}
